import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartModule } from 'primeng/chart';
import type { DashboardData } from '../../../services/dashboard.service';
import { formatDashboardCurrency } from '../dashboard-utils';

@Component({
  selector: 'app-dash-sales-chart',
  templateUrl: './dash-sales-chart.widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ChartModule],
  styles: [':host { display: block; height: 100%; }']
})
export class DashSalesChartWidgetComponent {
  data = input<DashboardData | null>(null);

  readonly formatCurrency = formatDashboardCurrency;

  readonly chartData = computed(() => {
    const rows = this.data()?.salesByDay ?? [];
    return {
      labels: rows.map((r) => r.date.slice(5)),
      datasets: [
        {
          label: 'Facturación (total)',
          data: rows.map((r) => r.total),
          fill: true,
          tension: 0.4,
          borderColor: 'rgba(99, 102, 241, 0.7)',
          borderWidth: 1.5,
          backgroundColor: 'rgba(99, 102, 241, 0.07)',
          pointRadius: 0,
          pointHoverRadius: 3,
          pointHoverBackgroundColor: 'rgb(99, 102, 241)'
        }
      ]
    };
  });

  readonly chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: true, position: 'top' as const } },
    scales: {
      x: {
        border: { display: false },
        grid: { color: 'rgba(0,0,0,0.04)', lineWidth: 1 },
        ticks: { color: '#94a3b8', font: { size: 11 } }
      },
      y: {
        beginAtZero: true,
        border: { display: false, dash: [4, 4] },
        grid: { color: 'rgba(0,0,0,0.05)', lineWidth: 1 },
        ticks: { color: '#94a3b8', font: { size: 11 } }
      }
    }
  };

  readonly periodTotal = computed(() =>
    (this.data()?.salesByDay ?? []).reduce((s, r) => s + r.total, 0)
  );
}
